import React, { Component } from 'react';

import { Row, Col, InputGroup } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';

/**
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
*/

import CommonButton from '../components/CommonButton';

class SearchTypeADuolCoop extends Component {

    render = () => {
        let props = this.props;

        let { onInputChange, onSearch } = props;

        let { Action, Searchs, InputGroup: InputGroups, Masterbase, Operation } = props;

        let { target_industries_id, faculty_id , academy_name } = Searchs; 

        if(Operation.Search !== true) return null;

        return (
            <>
                <Row className="ms-2 me-2">
                    <Col md={12} className="custom-search-panel-body">
                        <Row> 
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{target_industries_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={target_industries_id}
                                        option={{source: 'db', data: Masterbase?.target_industries}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col> 
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{faculty_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={faculty_id}
                                        option={{source: 'db', data: Masterbase?.faculty}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col> 
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{academy_name.label}</InputGroup.Text>
                                    <CommonInput
                                        element="Searchs"
                                        input={academy_name}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>  
                            <Col md={3}>
                                <CommonButton 
                                    task="search" 
                                    disabled={Action.Loading.search ? true : false}
                                    callback={(e) => onSearch(e)} 
                                />
                            </Col>
                        </Row>                        
                    </Col>
                </Row>
            </>
        )
    }
}

export default SearchTypeADuolCoop;